<template>
    <div class="container">
        <div class="row  main__boxes justify-content-center" v-if="user.user_type_id!=5">
            <div class="col-12 col-lg-4 dashboard__box-col d-flex justify-content-center"> 
              <router-link :to="{name: 'StationaryTraining'}" class="button button--filled-blue-heighter">Zapisz się na szkolenie stacjonarne</router-link>
            </div>
            <div class="col-12 col-lg-4 dashboard__box-col d-flex justify-content-center">
              <router-link :to="{name: 'OnlineTraining'}" class="button button--filled-dark-heighter">Weź udział w szkoleniu online</router-link>
            </div>
        </div>

        <page-box-set-widget></page-box-set-widget>
    </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'CalendarComponent',
  data () {
    return {
      events: []
    }
  },
  beforeRouteEnter(to, from, next) {
    /**
     * Get current user object.
     */

    Vue.axios.all([
      Vue.axios({
        method: 'get',
        url: '/users/dates'
      })
    ])
    .then(Vue.axios.spread((datesResponse) => {
      next(vm => {
          vm.events = datesResponse.data.data.dates
      })
    }))
    .catch(error => next(false))
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  mounted: function() {
    if( !this.user || this.user.id != 1 ) {
        this.$gtag.pageview({
            page_path: '/szkolenia',
        })
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/app/home/calendar/CalendarComponent.vue